import { Parser } from '@json2csv/plainjs';
import { saveAs } from 'file-saver';
import { startCase } from 'lodash';
import { DataExporterFactory } from './data-exporter.factory';

export class CsvDataExporter implements DataExporterFactory {
  exportJson(filename: string, data: object[]) {
    if (!data.length) {
      saveAs(new Blob(['']), `${filename}.csv`);
      return;
    }

    const parser = new Parser({
      fields: Object.keys(data[0] || {}).map((key) => ({
        value: key,
        label: startCase(key),
      })),
    });
    const csv = parser.parse(data);

    saveAs(new Blob([csv]), `${filename}.csv`);
  }
}
